import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    minWidth: 350,
    maxWidth: 350,

    '& > form': {
      padding: '0.8rem',
      display: 'flex',
      flexDirection: 'column',

      '& > label': {
        margin: 0,

        '& .MuiTypography-body1': {
          fontSize: '1.4rem',
          fontWeight: 600,
          flex: 1,

          '& .MuiSvgIcon-root, & .MuiCircularProgress-root': {
            color: '#C1C9BE',
            margin: '0.8rem',

            '&.MuiCircularProgress-root': {
              marginRight: '1rem',
            },
          },
        },

        '& .MuiCheckbox-root': {
          color: theme.palette.secondary.main,

          '&.Mui-checked': {
            color: theme.palette.primary.dark,
          },
        },
      },

      '& > button': {
        marginTop: '0.8rem',
        margin: 0,
        padding: 0,
        width: '100%',
        height: '3.6rem',
      },
    },
  },
}))
